import { storeSimpleSettings, fetchSimpleSettings } from '@/service/shift/simpleSettings';
const { cloneDeep } = require('lodash');

function settingSimpleCtrl($scope) {
  $scope.simpleSettings = {};
  $scope.isFullEditMode = false;
  // 園の開始日
  $scope.firstDayOfTheMonth = 1;
  $scope.firstDays = [];

  /**
   * 編集モードの切り替え
   */
  const turnOnSettingEditMode = () => ($scope.isFullEditMode = true);
  const turnOffSettingEditMode = () => ($scope.isFullEditMode = false);

  /**
   * 編集用のコピーデータを作成
   */
  const setClonedSimpleSetting = () => {
    $scope.clonedFirstDayOfTheMonth = cloneDeep($scope.firstDayOfTheMonth);
  };

  /**
   * キャンセル
   */
  $scope.onClickCancelSimpleSetting = () => {
    $scope.firstDayOfTheMonth = $scope.clonedFirstDayOfTheMonth;
    turnOffSettingEditMode();
  };

  /**
   * シフトを表示する月のはじまりで選択可能な日付を用意
   * 1-27日まで選択可能に設定している
   * 28日以降も選択可能にすると、月によって表示条件の考慮が必要なため
   */
  $scope.settingDays = () => [...Array(27).keys()].map((i) => ++i);

  /**
   * 初期化処理
   */
  const initial = async () => {
    const fetchedSimpleSettings = await fetchSimpleSettings();
    $scope.simpleSettings = fetchedSimpleSettings;
    $scope.firstDayOfTheMonth = $scope.simpleSettings.firstDayOfTheMonth;
  };

  initial();

  /**
   * 基本設定を保存
   * @returns {*} fetchedSimpleSettings
   */
  const saveSimpleSetting = async () => {
    const { manageBreaks, publicationUnitCategory, shiftSummaryKeyCategory, unitTimeInMinutes, version } =
      $scope.simpleSettings;

    const payload = {
      firstDayOfTheMonth: $scope.firstDayOfTheMonth,
      manageBreaks,
      publicationUnitCategory,
      shiftSummaryKeyCategory,
      unitTimeInMinutes,
      version,
    };
    const fetchedSimpleSettings = await storeSimpleSettings(payload);
    return fetchedSimpleSettings;
  };

  /**
   * 基本設定を保存するボタンをクリック
   */
  $scope.onClickSaveSimpleSetting = async () => {
    if ($scope.firstDayOfTheMonth === $scope.simpleSettings.firstDayOfTheMonth) {
      turnOffSettingEditMode();
      return;
    }

    turnOffSettingEditMode();
    $scope.simpleSettings = await saveSimpleSetting();
  };

  /**
   * 編集モードに切り替え
   */
  $scope.switchSimpleSettingToEditMode = () => {
    setClonedSimpleSetting();
    turnOnSettingEditMode();
  };

  /**
   * シフトを表示する月のはじまりのイベント発火
   */
  $scope.onChangeFirstDayOfTheMonth = (firstDayOfTheMonth) => {
    $scope.firstDayOfTheMonth = firstDayOfTheMonth;
  };
}

angular.module('inspinia').controller('settingSimpleCtrl', settingSimpleCtrl);
